module.exports = {
  type: 'spa',
  isTenanted: true,
  publicPath: '/de-portal-home/',
  octopusPackageId: 'de-portal-home',
  octopusProjectName: 'DE Portal Home',
  mountDOMId: '__app__',
  standalone: false
};